import { memo, useCallback, useEffect, useRef, useState } from "react";
import { Button, Loader, PageHeader, Text, useTheme, type ModalRef } from "react-better-html";

import { useI18n } from "../../../utils/i18n";
import { useReduxAction, useReduxState, useSelectedOrganization } from "../../../utils/hooks";

import WorkspaceModal from "../../../components/modals/WorkspaceModal";
import PropertiesWorkspacesList from "../../../components/PropertiesWorkspacesList";

function Properties() {
   const theme = useTheme();
   const { t } = useI18n();
   const selectedOrganization = useSelectedOrganization();

   const workspaceModalRef = useRef<ModalRef>(null);

   const propertiesList = useReduxState((state) => state.properties.list);
   const workspacesList = useReduxState((state) => state.workspaces.list);

   const [page, setPage] = useState<number>(1);

   const getAllWorkspaces = useReduxAction((actions) => actions.workspaces.getAllWorkspaces);
   const getAllProperties = useReduxAction((actions) => actions.properties.getAllProperties);

   const onClickCreate = useCallback(() => {
      workspaceModalRef.current?.open();
   }, []);

   useEffect(() => {
      getAllProperties({
         query: {
            page,
         },
      });

      if (selectedOrganization?.type === "PERSONAL") {
         getAllWorkspaces();
      }
   }, [page, selectedOrganization]);

   return selectedOrganization ? (
      <>
         <PageHeader
            title={t((l) => l.pages.properties.title[selectedOrganization.type])}
            titleAs="h2"
            titleRightElement={
               propertiesList ? (
                  <Text
                     fontSize={14}
                     color={theme.colors.textSecondary}
                  >{`${propertiesList.items.length ?? 0} ${t((l) => (propertiesList.items.length === 1 ? l.common.property : l.common.properties))}`}</Text>
               ) : (
                  <Loader.text fontSize={14} size={10} />
               )
            }
            rightElement={
               <Button icon="plus" text={t((l) => l.pages.properties.createWorkspace)} onClick={onClickCreate} />
            }
            marginBottom={theme.styles.space}
         />

         <PropertiesWorkspacesList
            properties={propertiesList}
            workspaces={selectedOrganization.type === "PERSONAL" ? workspacesList : undefined}
            page={page}
            onChangePage={setPage}
         />

         <WorkspaceModal ref={workspaceModalRef} />
      </>
   ) : (
      <Loader.box />
   );
}

export default memo(Properties);
